import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  //baseURL: "https://db.bongagames.co.ke/api/",
  //baseURL: "http://localhost:12300/api/",
  baseURL: "https://db.stagames.co.ke/api/"
});

const writeAxiosInstance = axios.create({
  //baseURL: "https://fun.db.ibibe.africa/api/",
  //baseURL: "http://localhost:12300/api/",
  //baseURL: "https://db.bongagames.co.ke/api/",
  baseURL: "https://db.stagames.co.ke/api/",

});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;